import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import { BookUser, FilePenLine, FileStack, ReceiptEuro, Users } from 'lucide-react'

export default function Dashboard() {
    const { t } = useTranslation()

    return (
        <Container className='p-1 py-5 p-md-5'>
            <Row>
                <Col>
                    <div className='sd-label-dashboard'>{t('welcome')}</div>
                </Col>
            </Row>
            <Row className='mb-5'>
                <Col>
                    <h3>{t('subwelcome')}</h3>
                </Col>
            </Row>
            <Row>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.commercial")}/${t("url.clients")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <BookUser size={48} className="me-2" />
                                <h2 className='noBold'>{t('Clients')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.commercial")}/${t("url.policies")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <FilePenLine size={48} className="me-2" />
                                <h2 className='noBold'>{t('Policies')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.commercial")}/${t("url.sinesters")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <img src="/images/sinester.svg" alt="example" className="me-2" width={48} height={48}/>
                                <h2 className='noBold'>{t('Sinesters')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.commercial")}/${t("url.receipts")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <ReceiptEuro size={48} className="me-2" />
                                <h2 className='noBold'>{t('Receipts')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.clerk")}/${t("url.documents")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <FileStack size={48} className="me-2" />
                                <h2 className='noBold'>{t('Documents')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </Container>
    )
}